<template>
  <path
    d="M20 6.00024H16V4.00024C16 2.89024 15.11 2.00024 14 2.00024H10C8.89 2.00024 8 2.89024 8 4.00024V6.00024H4C2.89 6.00024 2.01 6.89024 2.01 8.00024L2 19.0002C2 20.1102 2.89 21.0002 4 21.0002H20C21.11 21.0002 22 20.1102 22 19.0002V8.00024C22 6.89024 21.11 6.00024 20 6.00024ZM14 6.00024H10V4.00024H14V6.00024Z"
  />
</template>
